import type { ITelemetryItem } from '@microsoft/applicationinsights-web';

/**
 * Custom property name the organization ID is stamped under.
 * Must stay `OrgId`: the error-triage KQL queries rank groups by `dcount(Properties.OrgId)`,
 * and dynamic property access in KQL is case-sensitive.
 */
export const ORG_ID_PROPERTY = 'OrgId';

/**
 * Stamps the organization ID onto a telemetry item's custom properties so browser telemetry
 * carries the same org dimension as the backend's. Leaves the item untouched when there is no
 * org, and never overwrites an OrgId the caller set explicitly.
 * @param item - Telemetry item about to be sent
 * @param orgId - Currently selected organization ID, or null when none is selected
 */
export function stampOrgId(item: ITelemetryItem, orgId: string | null): void {
  if (!orgId) {
    return;
  }

  item.baseData ??= {};
  const properties = ((item.baseData.properties as Record<string, unknown> | undefined) ??= {});
  if (properties[ORG_ID_PROPERTY] === undefined) {
    properties[ORG_ID_PROPERTY] = orgId;
  }
}
